<div class="modal-header">
    <h2 class="modal-title">{{ azione }} sopralluogo</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <form class="form" role="form" [formGroup]="criteriaForm">
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="idTipologia">Tipologia rilevamento</label>
                <select class="form-control" formControlName="idTipologia" id="idTipologia">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.tipologiaRilevamento" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="idFonte">Fonte</label>
                <select class="form-control" formControlName="idFonte" id="idFonte">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.fonte" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="idTipoEvento">Tipo evento</label>
                <select class="form-control" formControlName="idTipoEvento" id="idTipoEvento">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.evento" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="rilevatore">Rilevatore</label>
                <input class="form-control" id="rilevatore" formControlName="rilevatore" type="text">
            </div>
            <div class="form-group col-md-4">
                <app-toolkit-datepicker
                    id="dataRilevamento"
                    label="Data sopralluogo"
                    formControlName="dataRilevamento"
                    [disabled]="criteriaForm.controls['dataRilevamento'].disabled">
                </app-toolkit-datepicker>
            </div>
            <div class="form-group col-md-4">
                <label for="efficienza">Efficienza</label>
                <select class="form-control" formControlName="efficienza" id="efficienza">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.fascePercentuali" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="efficacia">Efficacia</label>
                <select class="form-control" formControlName="efficacia" id="efficacia">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.fascePercentuali" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <app-toolkit-datepicker
                    id="dataEvento"
                    label="Data evento"
                    formControlName="dataEvento"
                    [disabled]="criteriaForm.controls['dataEvento'].disabled">
                </app-toolkit-datepicker>
            </div>
            <div class="form-group col-md-4">
                <label for="richiestaFinanziamento">Richiesta di finanziamento (€)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '€ ', thousands: '.', decimal: ',' }" class="form-control" id="richiestaFinanziamento" formControlName="richiestaFinanziamento" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="entitaDanno">Entità danno</label>

                <!-- Modalità modifica/inserimento -->
                <select *ngIf="azione !== 'Visualizza'" class="form-control" formControlName="entitaDanno" id="entitaDanno">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.livelloDanno" [ngValue]="item.id">
                        {{ item.descrizione }}
                    </option>
                </select>

                <!-- Modalità visualizzazione con select disabilitata -->
                <select *ngIf="azione === 'Visualizza'" class="form-control" disabled>
                    <option>
                        {{
                            entitaDannoLabel
                        }}
                    </option>
                </select>
            </div>
            <div class="form-group col-md-12">
                <label for="descrizioneEvento">Descrizione evento</label>
                <textarea class="form-control" id="descrizioneEvento" formControlName="descrizioneEvento" type="text"></textarea>
            </div>
            <div class="form-group col-md-12">
                <label for="descrizioneDanno">Descrizione danno</label>
                <textarea class="form-control" id="descrizioneDanno" formControlName="descrizioneDanno" type="text"></textarea>
            </div>
            <div class="form-group col-md-12">
                <label for="propostaIntervento">Proposta di intervento</label>
                <textarea class="form-control" id="propostaIntervento" formControlName="propostaIntervento" type="text"></textarea>
            </div>
            <div class="form-group col-md-12">
                <label for="note">Note</label>
                <textarea class="form-control" id="note" formControlName="note" type="text"></textarea>
            </div>
        </div>
    </form>
    <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
</div>
<div class="modal-footer">
    <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
    <button *ngIf="canEdit" type="button" tabindex="0" (click)="saveSopralluogo()" class="btn btn-primary">Salva</button>
</div>